module.exports = __webpack_public_path__ + "static/media/S12_B.e91d61d1.png";